export default __webpack_public_path__ + "static/media/slide2.bda30b93.png";